var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", [
    _c("div", { staticClass: "navigation__container" }, [
      _c("div", { staticClass: "nav__links" }, [
        _c("img", {
          attrs: {
            src: _vm.mediaBaseUrl + "landing/burger.svg",
            alt: "burger menu"
          },
          on: {
            click: function($event) {
              _vm.showMenu = true
            }
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "menu" },
          _vm._l(_vm.links, function(link) {
            return _c(
              "a",
              {
                key: link.name,
                class: { link_active: link.active },
                on: {
                  click: function() {
                    return _vm.handleLink(link.route, link.name)
                  }
                }
              },
              [_vm._v(_vm._s(link.name))]
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "nav__buttons" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.user === null,
                expression: "user === null"
              }
            ],
            staticClass: "nav__buttons"
          },
          [
            _c(
              "custom-button",
              {
                attrs: { outlined: true, small: true },
                on: { click: _vm.handleLoginClick }
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("landing.menu[4]")) +
                    "\n          "
                )
              ]
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "menu",
        class: { menu_active: _vm.showMenu },
        on: {
          click: function($event) {
            _vm.showMenu = false
          }
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "close",
            on: {
              click: function($event) {
                _vm.showMenu = false
              }
            }
          },
          [
            _c("img", {
              attrs: { src: _vm.mediaBaseUrl + "close.svg", alt: "close" }
            })
          ]
        ),
        _vm._v(" "),
        _vm._l(_vm.links, function(link) {
          return [
            _c(
              "a",
              {
                key: link.name,
                on: {
                  click: function() {
                    return _vm.handleLink(link.route, link.name)
                  }
                }
              },
              [_vm._v(_vm._s(link.name))]
            )
          ]
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }